<fl-cookie-consent-dialog [consent]="consent()" [show]="show()" (save)="service.save($event)" />
